import { winhydro as api } from '../../../actions/api';

export const dischargeGenerate = (data, station) => new Promise((resolve) => {
  const payload = data.map(item => ({ station_id: station.id, time: item.time, stage: item.value }));
  api.getDischargeUsingRatingEquation(payload)
    .then(res => {
      resolve(res.map(item => ({ time: item.time, value: item.discharge })));
    })
    .catch(err => {
      console.log(err);
      resolve(data.map(item => ({ time: item.time, value: null })));
    });
});


// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/dischargeGenerator.js